var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('editor',_vm._g({staticClass:"form-control",attrs:{"value":_vm.value,"lang":"ftl","theme":"github","height":"492"},on:{"init":_vm.editorInit}},_vm.inputListeners))}
var staticRenderFns = []

export { render, staticRenderFns }